import { render, staticRenderFns } from "./ServerResponseLayout.vue?vue&type=template&id=b25e86ae&scoped=true"
import script from "./ServerResponseLayout.vue?vue&type=script&lang=js"
export * from "./ServerResponseLayout.vue?vue&type=script&lang=js"
import style0 from "./ServerResponseLayout.vue?vue&type=style&index=0&id=b25e86ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25e86ae",
  null
  
)

export default component.exports